import { atom } from 'recoil';

export declare namespace TokenStateTypes {
  interface TokenStatus {
    value: string | null;
    isValid: boolean | null;
    isExpired: boolean | null;
  }
}

export const tokenState = atom<TokenStateTypes.TokenStatus>({
  key: 'tokenState',
  default: {
    value: null,
    isValid: null,
    isExpired: null,
  },
});
